import api from "./api";

const QUEUE_KEY = "kleana_offline_queue";
const CACHE_PREFIX = "kleana_cleans_";

export function loadQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
  } catch {
    return [];
  }
}

export function saveQueue(q) {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(q));
}

export function enqueue(event) {
  const q = loadQueue();
  q.push(event);
  saveQueue(q);
}

export function cacheCleans(date, cleans) {
  localStorage.setItem(CACHE_PREFIX + date, JSON.stringify(cleans));
}

export function getCachedCleans(date) {
  try {
    return JSON.parse(localStorage.getItem(CACHE_PREFIX + date) || "null");
  } catch {
    return null;
  }
}

// mirror of backend apply_action so offline state stays consistent
export function applyActionLocal(clean, action, ts) {
  const c = { ...clean };
  const session = c.session
    ? { ...c.session, breaks: [...(c.session.breaks || [])] }
    : { status: "pending", started_at: null, ended_at: null, breaks: [] };

  if (action === "start_clean") {
    if (!session.started_at) session.started_at = ts;
    session.status = "in_progress";
    session.ended_at = null;
  } else if (action === "end_clean") {
    session.breaks = session.breaks.map((b) => (b.end == null ? { ...b, end: ts } : b));
    session.ended_at = ts;
    session.status = "completed";
  } else if (action === "start_break") {
    const last = session.breaks[session.breaks.length - 1];
    if (!last || last.end != null) session.breaks.push({ start: ts, end: null, type: "break" });
    session.status = "paused";
  } else if (action === "start_lunch") {
    const last = session.breaks[session.breaks.length - 1];
    if (!last || last.end != null) session.breaks.push({ start: ts, end: null, type: "lunch" });
    session.status = "paused";
  } else if (action === "end_break") {
    const last = session.breaks[session.breaks.length - 1];
    if (last && last.end == null) session.breaks[session.breaks.length - 1] = { ...last, end: ts };
    session.status = "in_progress";
  }
  c.session = session;
  return c;
}

export function computeActualSeconds(session) {
  if (!session || !session.started_at) return 0;
  const start = new Date(session.started_at).getTime();
  const end = session.ended_at ? new Date(session.ended_at).getTime() : Date.now();
  let total = (end - start) / 1000;
  for (const b of session.breaks || []) {
    if (!b.start) continue;
    const bs = new Date(b.start).getTime();
    const be = b.end ? new Date(b.end).getTime() : end;
    total -= Math.max(0, (be - bs) / 1000);
  }
  return Math.max(0, Math.round(total));
}

let syncing = false;

export async function flushQueue() {
  if (syncing) return { flushed: 0 };
  const q = loadQueue();
  if (q.length === 0) return { flushed: 0 };
  syncing = true;
  try {
    const { data } = await api.post("/sync", { events: q });
    saveQueue([]);
    return { flushed: q.length, results: data.results || [] };
  } catch (e) {
    return { flushed: 0, error: true };
  } finally {
    syncing = false;
  }
}
